function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import excludeVariablesFromRoot from "./excludeVariablesFromRoot.js";
export default (function (theme) {
  return function (colorScheme, css) {
    var root = theme.rootSelector || ':root';
    var selector = theme.colorSchemeSelector;
    var rule = selector;
    if (selector === 'class') {
      rule = '.%s';
    }
    if (selector === 'data') {
      rule = '[data-%s]';
    }
    if (selector !== null && selector !== void 0 && selector.startsWith('data-') && !selector.includes('%s')) {
      // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
      rule = "[".concat(selector, "=\"%s\"]");
    }
    if (theme.defaultColorScheme === colorScheme) {
      if (colorScheme === 'dark') {
        var excludedVariables = {};
        excludeVariablesFromRoot(theme.cssVarPrefix).forEach(function (cssVar) {
          excludedVariables[cssVar] = css[cssVar];
          delete css[cssVar];
        });
        if (rule === 'media') {
          return _defineProperty(_defineProperty({}, root, css), "@media (prefers-color-scheme: dark)", _defineProperty({}, root, excludedVariables));
        }
        if (rule) {
          return _defineProperty(_defineProperty({}, rule.replace('%s', colorScheme), excludedVariables), "".concat(root, ", ").concat(rule.replace('%s', colorScheme)), css);
        }
        return _defineProperty({}, root, _objectSpread(_objectSpread({}, css), excludedVariables));
      }
      if (rule && rule !== 'media') {
        return "".concat(root, ", ").concat(rule.replace('%s', String(colorScheme)));
      }
    } else if (colorScheme) {
      if (rule === 'media') {
        return _defineProperty({}, "@media (prefers-color-scheme: ".concat(String(colorScheme), ")"), _defineProperty({}, root, css));
      }
      if (rule) {
        return rule.replace('%s', String(colorScheme));
      }
    }
    return root;
  };
});